var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"classRewards"}},[_c('index',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("德育")]),_c('el-breadcrumb-item',[_c('a',{staticStyle:{"color":"#000000"}},[_vm._v("文明班评比")])])],1),_c('v-weburl-iframe',{staticClass:"content",attrs:{"url":"moral/fine"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }